// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__gbOgf","buttons":"PendingPaymentAlert_buttons__1a0et"};